import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "api";
import { STATUS } from "utils/status";
import { AnalyticsPayload, VendorAnalyticsCompletedState } from '../../interfaces/interface';
import extraReducers from '../../extraReducers/vendorAnalytics';

const initialState: VendorAnalyticsCompletedState = {
  VendorAnalyticsCompleted: {
    count: undefined,
    data: []
  },
  VendorAnalytics: {
    count: undefined,
    data: []
  },
  error: null,
  getVendorAnalyticsStatus: STATUS.NOT_STARTED,
  getVendorAnalyticsMessage: "",
  getVendorStatus: STATUS.NOT_STARTED,
  getVendorMessage: ""
};

export const getCompletedVendorAnalytics = createAsyncThunk('project/qa-analytics/overview/vendor/get',
  async (payload: AnalyticsPayload = {}, thunkAPI) => {
    try {
      const { search, page, pageSize, sort_by, sort_order, project_id } = payload;
      const response = await api.get('project/company/vendor-analytics/vendors', {
        params: {
          search,
          page,
          page_size: pageSize,
          sort_by,
          sort_order,
          project_id,
          tab: 'vendors',
        },
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;

        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);

export const getVendorAnalytic = createAsyncThunk('/project/company/vendor/stage-wise-analytics/v2/get',
  async (payload: AnalyticsPayload = {}, thunkAPI) => {
    try {
      const { vendor_id, project_id } = payload;
      const response = await api.get('/project/company/vendor/stage-wise-analytics/v2/', {
        params: {
          vendor_id,
          project_id,
        },
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;

        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);

const vendoranalyticsCompletedSlice = createSlice({
  name: 'vendorAnalyticsCompleted',
  initialState,
  reducers: {
  },
  extraReducers
});

export default vendoranalyticsCompletedSlice.reducer;


